import {Box, Card, Stack} from '@mui/material';
import React, {Fragment, useCallback} from 'react';
import {useNavigate} from 'react-router-dom';

import {IconIllustration, MainFooter, MainHeader, StyledGrid} from 'presentation/components';
import {ProfileEnum} from 'presentation/constants';
import {BeneficiaryCard} from 'presentation/pages/private/profile/components';
import {CodeValidationForm, CreatePasswordStrength, useSteps} from 'presentation/pages/public';
import {translations} from 'presentation/translations-new';
import {getPageHeaderTitle} from 'presentation/utils';

import {PublicFlowEnum} from 'presentation/pages/public/constants/PublicFlowEnum';
import {PATH_TITLE} from '../../booking/constants';
import {useAccountInformation, useMediaQueries} from '../../hooks';

import {ResendTokenStack} from './styles';

const {title} = translations['pt-br'].privateFlow.profile;

export function ChangePassword() {
	const {isLaptop} = useMediaQueries();
	const navigate = useNavigate();

	const {isResponsibleWithoutBenefits} = useAccountInformation();

	const {currentStepState} = useSteps(PublicFlowEnum.FORGOT_PASSWORD);

	const STEP_PAGE: Record<number, React.JSX.Element> = {
		1: <CodeValidationForm flowType={PublicFlowEnum.FORGOT_PASSWORD} privateFlow />,
		2: <CreatePasswordStrength flowType={PublicFlowEnum.FORGOT_PASSWORD} privateFlow />,
	};

	const pageTitle = getPageHeaderTitle({internalPaths: PATH_TITLE, mainPath: title});

	const handleBack = useCallback(() => {
		navigate(ProfileEnum.PROFILE);
	}, []);

	return (
		<Fragment>
			<MainHeader
				title={pageTitle}
				handleBack={handleBack}
				handleClose={handleBack}
				variant="subRoute"
			/>
			<Stack padding={isLaptop ? 0 : 4} flex={1}>
				<StyledGrid.Root>
					<StyledGrid.Item sm={12} md={12} lg={8}>
						<Card
							elevation={0}
							sx={{
								borderRadius: isLaptop ? 0 : 2,
							}}>
							<ResendTokenStack padding={3} spacing={2}>
								{isLaptop ? (
									<Box width={80}>
										<IconIllustration
											variant="info"
											customIconName="closed-padlock"
											size="big"
										/>
									</Box>
								) : null}
								{STEP_PAGE[currentStepState]}
							</ResendTokenStack>
						</Card>
					</StyledGrid.Item>
					{isLaptop ? null : (
						<StyledGrid.Item sm={12} md={12} lg={4}>
							<BeneficiaryCard
								isResponsibleWithoutBenefits={isResponsibleWithoutBenefits}
							/>
						</StyledGrid.Item>
					)}
				</StyledGrid.Root>
			</Stack>
			<Box mt="auto">
				<MainFooter />
			</Box>
		</Fragment>
	);
}
